import React from "react";
import { Pagination, PaginationProps } from "@mantine/core";
import { primary } from "../../../constants/color-constants";
import "./style.css";

interface PaginationComponentProps extends PaginationProps {
  total: number;
  value: number;
  onChange: (page: number) => void;
}

const PaginationComponent: React.FC<PaginationComponentProps> = ({
  total,
  value,
  onChange,
  ...rest
}) => {
  return (
    <Pagination
      color={primary[2]}
      total={total}
      value={value}
      onChange={onChange}
      radius='md'
      size='xs'
      gap={8}
      classNames={{
        control: "pagination-control",
      }}
      styles={{
        root: {
          display: "flex",
          justifyContent: "center",
          gap: "4px",
          paddingTop: "8px",
        },
        control: {
          border: "none",
          padding: "16px 12px",
          fontWeight: 500,
        },
      }}
      style={{
        ["--pagination-active-bg" as any]: primary[2],
        ["--pagination-active-color" as any]: primary[5],
      }}
      {...rest}
    />
  );
};

export default PaginationComponent;
